import React from "react";
import { DisplayMoney } from "../../components/workspace";
import { numberToMoney } from "../../utils/money";

function PriceSummary({ workCommission, saleCommission, grandTotal, jobsTotal, ttlPriceAdj, ttlCostTax, ttlCostMaterials, ttlCostLabor, profitTotal }) {

	const totatCost = ttlCostTax + ttlCostMaterials + ttlCostLabor;

  return (
		<>
			<h3 className="whole">Price Summary</h3>
			<div className="form-row one-third">
				<DisplayMoney name="Cost Tax" value={numberToMoney(ttlCostTax)} />
				<DisplayMoney name="Cost Materials" value={numberToMoney(ttlCostMaterials)} />
				<DisplayMoney name="Cost Labor" value={numberToMoney(ttlCostLabor)} />
				<DisplayMoney name="Total Cost" value={numberToMoney(totatCost)} />
			</div>
			<div className="form-row one-third">				
				<DisplayMoney name="Job Items Total" value={numberToMoney(jobsTotal)} />
				<DisplayMoney name="Net Discounts" value={numberToMoney(ttlPriceAdj)} />
				<DisplayMoney name="Grand Total" value={numberToMoney(grandTotal)} />
				<DisplayMoney name="Total Profit" value={numberToMoney(profitTotal)} />
			</div>
			<div className="form-row one-third">
				<DisplayMoney name="Total Sales Commission(s)" value={numberToMoney(saleCommission)} />
				<DisplayMoney name="Total Service Commission(s)" value={numberToMoney(workCommission)} />
				<DisplayMoney
					name="Company Profit"
					value={numberToMoney(profitTotal - saleCommission - workCommission)}
				/>
			</div>
		</>
	);
}
export default PriceSummary;
